export default {
  methods: {
    handleBrokenImage: function (event) {
      event.target.src = require('@/assets/paw.png')
    }
  }
}
